import n from "./constant.js";
import o from "./_defineProperty.js";
import i from "./identity.js";
var a = n, t = o, f = i, u = t ? function(e, r) {
  return t(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: a(r),
    writable: !0
  });
} : f, s = u;
export {
  s as default
};
//# sourceMappingURL=_baseSetToString.js.map
